/**
 * Helper object used by dateFormat to handle the position
 * of day, month and year fragments in different dateformats
 *
 * @access public
 * @param string format
 * @param string separator
 */
function dateFragmentIndex(format, separator) {
    var arrFormat    = format.split(separator);
    var arrIsoFormat = ['yy', 'mm', 'dd'];

    this.getDay = function() {
        for (index in arrFormat) {
            if (arrFormat[index] === 'dd') {
                return index;
            }
        }
    };

    this.getMonth = function() {
        for (index in arrFormat) {
            if (arrFormat[index] === 'mm') {
                return index;
            }
        }
    };

    this.getYear = function() {
        for (index in arrFormat) {
            if (arrFormat[index] === 'yy') {
                return index;
            }
        }
    };

    this.getFirst = function() {
        for (index in arrIsoFormat) {
            if (arrIsoFormat[index] === arrFormat[0]) {
                return index;
            }
        }
    };

    this.getSecond = function() {
        for (index in arrIsoFormat) {
            if (arrIsoFormat[index] === arrFormat[1]) {
                return index;
            }
        }
    };

    this.getThird = function() {
        for (index in arrIsoFormat) {
            if (arrIsoFormat[index] === arrFormat[2]) {
                return index;
            }
        }
    };
}

/**
 * Helper object used by dateFormat to find out which character
 * is separating day, month and year in different dateformats
 *
 * @access public
 * @param string format
 */
function dateSeparator(format) {
    this.getString = function() {
        return format.replace(/[dmyDMY]/g, '').substr(0, 1);
    };

    this.getKeyCode = function() {
        return this.getString().charCodeAt(0);
    };
}

/**
 * Converts a date into given format.
 * Incomplete dates will be adjusted.
 *
 * @access public
 * @param string format
 */
function dateFormat(format) {
    var date = new Date();

    var formatDay = function(day, month, year) {
        if (isNaN(day) || (day.length === 0 && month.length === 0 && year.length === 0)) {
            day = date.getDate();
        } else if (day.length === 0 && (month.length > 0 || year.length > 0)) {
            day = '01';
        } else if(day.length > 2) {
            day = day.substring(0, 2);
        }

        var getLastDateInMonth = function() {
            month = (month.length === 0) ? date.getMonth()    + 1 : month;
            year  = (year.length  === 0) ? date.getFullYear() + 1 : year;

            var lastDateInMonth = new Date(year, month, 1);
            lastDateInMonth.setTime(lastDateInMonth.getTime() - 12 * 3600 * 1000);

            return lastDateInMonth.getDate();
        };

        var lastDateInMonth = getLastDateInMonth();

        if (day > lastDateInMonth) {
            day = lastDateInMonth;
        };

        return day;
    };

    var formatMonth = function(month, year) {
        if (isNaN(month) || (month.length === 0 && year.length === 0)) {
            month = date.getMonth() + 1;
        } else if (month.length === 0 && year.length > 0) {
            month = '01';
        } else if(month.length > 2) {
            month = parseInt(month.substring(0, 2));
        }

        if (month > 12) {
            month = '12';
        }

        return month;
    };

    var formatYear = function(year) {
        if (isNaN(year) || year.length === 0) {
            year = date.getFullYear();
        } else if(year.length > 4) {
            year = year.substring(0, 4);
        } else if(year.length === 1) {
            year = '200' + year;
        } else if(year.length === 2) {
            if (year < 20) {
                year = '20' + year;
            } else {
                year = '19' + year;
            }
        } else if(year.length === 3) {
            year = '1' + year;
        }

        if(year > date.getFullYear() + 50) {
            year = date.getFullYear();
        }

        return year;
    };

    this.i18nToIso = function(i18nDate) {
        if (i18nDate.length === 0) {
            return values = {
                i18n: '',
                iso: ''
            };
        }

        var sep = new dateSeparator(format).getString();
        var dfi = new dateFragmentIndex(format, sep);
        var arrI18nDate = i18nDate.split(sep);

        var year  = arrI18nDate[dfi.getYear()]  || '';
        var month = arrI18nDate[dfi.getMonth()] || '';
        var day   = arrI18nDate[dfi.getDay()]   || '';

        var isoDate = $.datepicker.formatDate('yy-mm-dd', new Date(formatYear(year),
                                                                   formatMonth(month, year) - 1,
                                                                   formatDay(day, month, year)));
        var arrIsoDate = isoDate.split('-');

        i18nDate = [arrIsoDate[dfi.getFirst()],
                    arrIsoDate[dfi.getSecond()],
                    arrIsoDate[dfi.getThird()]].join(sep);

        return values = {
            i18n: i18nDate,
            iso: isoDate
        };
    };

    this.isoToI18n = function(isoDate) {
        if (isoDate.length === 0) {
            return '';
        }

        var sep = new dateSeparator(format).getString();
        var dfi = new dateFragmentIndex(format, sep);

        var arrIsoDate = isoDate.split('-');

        var i18nDate = [arrIsoDate[dfi.getFirst()],
                    arrIsoDate[dfi.getSecond()],
                    arrIsoDate[dfi.getThird()]].join(sep);

        return i18nDate;
    };
}

/**
 * complete date format
 *
 * @param   string   date
 * @param   string  format
 * @returns string
 */
function autocompleteDate(date, format) {
    format = format || pool.dateFormat;

    var value = date,
        formatParts = format.split(/[^\w]/g).filter(String),
        valueParts = value.split(/[^\w]/g).filter(String),
        i,
        posDay,
        posMonth,
        posYear,
        completedDate
    ;

    // Return input date if input date doesn't contain 3 elements
    if (valueParts.length !== 3) {
        return date;
    }

    // Get day, month and day
    for (i in formatParts) {
        var current = formatParts[i];
        if (current.search(/dd/) !== -1) { posDay = i; }
        if (current.search(/mm/) !== -1) { posMonth = i; }
        if (current.search(/yy/) !== -1) { posYear = i; }
    }

    try {posDay, posMonth, posYear; } catch(e) {
        console.error('unrecognized date format!');
        return date;
    }

    // Combine date elements
    if (valueParts.length === 3) {
        var day = valueParts[posDay],
            month = valueParts[posMonth],
            year = parseInt(valueParts[posYear], 10)
        ;

        // Check elements length
        if (day.length > 2 || month.length > 2 ||year.length > 4) {
            return date;
        }

        // Check elements type, auto complete missing zeros and  and combine elements
        if ((isNaN(day) || isNaN(month) || isNaN(year)) === false) {
            if (day.length < 2)   { day   = '0' + day; }
            if (month.length < 2) { month = '0' + month; }
            if (year < 1000)      { year  += (year >= 100 ? 0 : (year > 20 ? 1900 : 2000)); }

            // Combine date elements
            completedDate = format;
            completedDate = completedDate.replace('dd', day);
            completedDate = completedDate.replace('mm', month);
            completedDate = completedDate.replace('yy', year);

            return completedDate;
        } else {
            return value;
        }
    } else {
        return value;
    }
}

/**
 * convert date (iso->i18n, i18n->iso)
 *
 * @param   string  date
 * @param   string  format
 * @returns string
 */
function convertDate(date, format) {
    // Check whether date is filled
    if (date === undefined) {
        return date;
    }

    format = format || 'iso';

    var
        from = {
            value : date,
            valueParts : null,
            format : format === 'iso' ? pool.dateFormat : 'yy-mm-dd',
            separator : null,
            formatParts : null
        },
        to   = {
            value : null,
            valueParts : [],
            format : format === 'iso' ? 'yy-mm-dd' : pool.dateFormat,
            separator : null,
            formatParts : null
        },
        i, k, v, j
    ;

    from.separator = format === 'iso' ? /[^\w]/g : '-';
    to.separator   = format === 'iso' ? '-' : /[^\w]/g;

    from.formatParts = from.format.split(from.separator).filter(String);
    to.formatParts = to.format.split(to.separator).filter(String);

    from.valueParts  = from.value.split(from.separator).filter(String);

    // Return input date if input date doesn't contain 3 elements
    if (from.valueParts.length !== 3) {
        return date;
    }

    // Return input dates elements aren't a number or empty
    for (v in from.valueParts) {
        if (isNaN(from.valueParts[v]) || from.valueParts[v].length === 0) {
            return from.value;
        }
    }

    // Map from format parts to to format parts
    for (i in to.formatParts) {
        var currentPart = to.formatParts[i];
        var oldPos = false;
        var newPos = i;

        for (k in from.formatParts) {
            var fromPart = from.formatParts[k];
            if (fromPart === currentPart) {
                oldPos = k;
                break;
            }
        }
        if (oldPos !== false) {
            to.valueParts[newPos] = from.valueParts[oldPos];
        }
    }
    
    // Replace format parts in to object
    to.value = to.format;
    for (j = 0; j < 3; j++) {
        to.value = to.value.replace(to.formatParts[j], to.valueParts[j]);
    }

    return to.value;
}
